import Chip from "@mui/material/Chip";
import TextField from "@mui/material/TextField";
import Autocomplete, {
	type AutocompleteChangeDetails,
	type AutocompleteChangeReason,
} from "@mui/material/Autocomplete";
import type React from "react";
import type { CustomSelectProps, SelectOptions } from "../types";
import { getSortedOptions } from "../utils";

export default function CustomSelect(props: CustomSelectProps) {
	const {
		options,
		value,
		setValue,
		label,
		single,
		sort,
		disableEmpty,
		disableClearable,
		...otherprops
	} = props;

	const handleChange = (
		event: React.SyntheticEvent,
		newValue: SelectOptions | SelectOptions[] | null,
		reason: AutocompleteChangeReason,
		details?: AutocompleteChangeDetails<SelectOptions>,
	) => {
		if (reason === "clear") {
			setValue([options[0]]);
		} else if (
			reason === "selectOption" &&
			single &&
			props.multiple !== false &&
			newValue !== null
		) {
			const val = (newValue as SelectOptions[]).filter(
				(val) => val.label === (event.target as HTMLElement).textContent,
			);
			setValue(val);
		} else if (sort && reason === "selectOption" && newValue !== null) {
			setValue(getSortedOptions(newValue as SelectOptions[]));
		} else if (reason !== "removeOption" && newValue !== null) {
			setValue(newValue);
		} else if (reason === "removeOption" && disableEmpty && newValue !== null) {
			if ((newValue as SelectOptions[]).length !== 0) {
				setValue(newValue);
			}
		}
	};

	return (
		<>
			<Autocomplete
				multiple
				options={options}
				value={value}
				onChange={handleChange}
				isOptionEqualToValue={(option, val) =>
					(option as SelectOptions).value === (val as SelectOptions).value
				}
				getOptionLabel={(option) => (option as SelectOptions).label}
				size="small"
				forcePopupIcon
				disableClearable={disableClearable}
				autoComplete
				style={{ margin: 0 }}
				disableCloseOnSelect={!single}
				{...otherprops}
				renderTags={(value, getTagProps) =>
					value.map((option, index) => {
						const disableSingleItemRemove =
							value.length === 1 && disableEmpty ? { onDelete: undefined } : {};
						return (
							<Chip
								label={(option as SelectOptions).label}
								size="small"
								{...getTagProps({ index })}
								{...disableSingleItemRemove}
							/>
						);
					})
				}
				getOptionDisabled={(option) =>
					(option as SelectOptions).disabled ? true : false
				}
				renderInput={(params) => {
					return <TextField {...params} variant="outlined" label={label} />;
				}}
			/>
		</>
	);
}
